export const FORGOT_PASSWORD_MESSAGES = {
    success: 'Please check your email for the confirmation code',
    error: 'Reseting password failed, please ensure your email is correct',
}

export const FORGOT_PASSWORD_SUBMIT_MESSAGES = {
    success: 'Successfully reset password',
    error: 'Failed to reset password',
}
